// Web standard: 1440px
export const WEB_BASE = 1440;

export const convertToVwWeb = (px: number): string => {
  return `${(px / WEB_BASE) * 100}vw`;
};

/**
 * @param designPx 
 * @param lockViewport 
 */
export const cappedVwWeb = (designPx: number, lockViewport: number = 1054): string => {
  const scale = lockViewport / WEB_BASE;
  const capPx = Math.round(designPx * scale);
  const vw = (designPx / WEB_BASE) * 100;
  return `min(${vw}vw, ${capPx}px)`;
};

// Mobile standard: 393px
export const convertToVwMob = (px: number): string => {
  return `${(px / 393) * 100}vw`;
};

// Breakpoint for Web/Mobile separation
export const MOBILE_BREAKPOINT = 670;

// Footer tends to break earlier on narrow desktop/tablet widths.
export const FOOTER_BREAKPOINT = 670;


